import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayFormat', function (dataStr, pattern = 'YYYY-MM-DD') {
  if (dataStr) {
    if (dataStr.toString().length < 13) {
      dataStr = dataStr * 1000
    }
    return moment(dataStr).format(pattern)
  }
})

Vue.filter('timeFormat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (dataStr) {
    if (dataStr.toString().length < 13) {
      dataStr = dataStr * 1000
    }
    return moment(dataStr).format(pattern)
  }
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

// 将时间戳处理为几天前，语言表达
Vue.filter('formatMsgTime', function (dataStr) {
  if (dataStr === undefined) {
    return ''
  }
  if (dataStr.toString().length < 13) {
    dataStr = dataStr * 1000
  }
  var result = ''
  var minute = 1000 * 60
  var hour = minute * 60
  var day = hour * 24
  var month = day * 30
  var year = month * 12
  var now = new Date().getTime()
  var diffValue = now - dataStr
  if (diffValue < 0) return
  var yaerC = diffValue / year
  var monthC = diffValue / month
  var weekC = diffValue / (7 * day)
  var dayC = diffValue / day
  var hourC = diffValue / hour
  var minC = diffValue / minute
  if (yaerC >= 1) {
    if (yaerC > 20) {
      result = '很久以前'
    } else {
      result = '' + parseInt(yaerC) + '年前'
    }
  } else if (monthC >= 1) {
    result = '' + parseInt(monthC) + '个月前'
  } else if (weekC >= 1) {
    result = '' + parseInt(weekC) + '周前'
  } else if (dayC >= 1) {
    result = '' + parseInt(dayC) + '天前'
  } else if (hourC >= 1) {
    result = '' + parseInt(hourC) + '小时前'
  } else if (minC >= 1) {
    result = '' + parseInt(minC) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
})
